import { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from '@mui/material';
import { PrivacyContent } from './PrivacyContent';

interface PrivacyDialogProps {
    open: boolean;
    onClose: () => void;
}

export function PrivacyDialog({ open, onClose }: PrivacyDialogProps) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    backgroundImage: 'none',
                },
            }}
        >
            <DialogTitle>Privacy Policy</DialogTitle>
            <DialogContent>
                <PrivacyContent language="en" />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}

export function usePrivacyDialog() {
    const [open, setOpen] = useState(false);
    return {
        privacyOpen: open,
        openPrivacy: () => setOpen(true),
        closePrivacy: () => setOpen(false),
    };
}